<template>
  <EditCom
    :title="title"
    :target="target"
    :buttonList="buttonList"
    :inputList="inputList"
    :rules="rules"
    :showClose="false"
    class="edit-polygon-container"
  >
    <template #KeyValSelect="{ input }">
      <el-scrollbar :max-height="200"
        class="event-select-scrollbar"
        v-if="input.prop === 'relatedPosition'"
      >
        <div class="event-select-item"
          v-for="(event, index) of eventList"
          :key="index"
          @click="eventClick(event)"
        >
          {{ event['eventTime'] }} {{ event['eventName'] }}
        </div>
        <div class="event-select-item event-all-select-item"
          @click="eventAllClick()"
          v-if="eventAllClickShowFlag"
        >
          查看更多
        </div>
      </el-scrollbar>
    </template>
  </EditCom>
</template>

<script setup>
import { 
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick, reactive, toRaw,
} from 'vue';
import { isNull, dayjs, message } from '@/utils/js/initVariable';
import store from '@/store';

import EditCom from '@/components/EditCom';
import * as turf from '@turf/turf'

import {
  saveGraphic, delGraphic, getEventListByCoordinates,
} from '@/api/UserDrawApi';

import { queryExposureProperties, getMapBoxPlacesGeometry } from '@/api/MapManage';
// props
const props = defineProps({
  title: { type: String, },
  target: { type: Object, },
  layer: { type: Object, },
  group: { type: Object, },
  layerRemoveFn: { type: Function, },
  selectListInitFn: { type: Function, },
  bizType: { type: Number, },
  close: { type: Function },
});

const homeMap = computed(() => store.getters.getHomeMap),
      map = toRaw(homeMap.value);

const customMarkerTypeProp = store.getters['leafletPolygon/customMarkerTypeProp'],
      customTextProp = store.getters['leafletPolygon/customTextProp'],
      customTextColorProp = store.getters['leafletPolygon/customTextColorProp'];

const tileMap = computed(()=> store.getters['homeTile/tileMap'] );

const checkAdmin = computed(() => store.getters['isSuperAdmin']);
// const target = ref({
//   ...props.target,
// });

const delFn = (form, item, button, loadFn, fn)=>{
  // console.log(item);
  if(props.close){
    props.close();
    return;
  }
  if(item['id']){
    delGraphic(item['id']).then(res=>{
      if(res.data.code == 1004){
        props.layerRemoveFn && props.layerRemoveFn(props.layer, props.group);
      }
    }).catch(err=>{
      console.log(err);
    });
  }else{
    props.layerRemoveFn && props.layerRemoveFn(props.layer);
  }
  loadFn && loadFn();
}

const submitFn = (item, button, loadFn, fn)=>{
  const layer = props.layer;
  if(!layer){
    message('无效图层', 2);
    return;
  }
  let geojson;
  if(layer instanceof L.Circle){
    const latlng = layer.getLatLng();
    geojson = turf.circle([latlng.lng, latlng.lat], layer.getRadius() / 1000, {
      steps: 64, units: 'kilometers',
    });
  }else{
    geojson = layer.toGeoJSON();
  }
  geojson = geojson['features']?geojson['features'].at(0):geojson;
  geojson['properties']['dashArray'] = item['dashArray'];
  geojson['properties']['fill'] = item['fill'];
  geojson['properties']['weight'] = item['weight'];

  geojson['properties'][customMarkerTypeProp] = item[customMarkerTypeProp];
  if(item[customMarkerTypeProp] == customTextProp){
    geojson['properties'][customTextProp] = item[customTextProp].replace('<br>', '').replace('undefined', '');
    geojson['properties'][customTextColorProp] = item[customTextColorProp];
  }
  // console.log(geojson);
  const data = {
    id: item['id'],
    favoriteId: item['favoriteId'],
    name: item['name'],
    purpose: item['purpose'],
    relatedInformation: JSON.stringify(item['relatedInformation']),
    relatedPosition: JSON.stringify(item['relatedPosition']),
    remark: item['remark'],
    geom: JSON.stringify(geojson),
    bizType: props.bizType,
  }
  // console.log(data);
  saveGraphic(data).then(res=>{
    if(res.data.code == 1004){
      // close();
      message(res.data.msg, 1);
      item['id'] = res.data.data;
      props.selectListInitFn && props.selectListInitFn();
      props.close && props.close();
    }
    loadFn && loadFn();
  }).catch(err=>{
    loadFn && loadFn();
    console.log(err);
  });
}
const submit = (form, item, button, loadFn, fn)=>{
  // console.log(form, item, button, loadFn, fn);
  form.value.validate((valid)=>{
    // console.log(valid);
    if(valid){
      submitFn(item, button, loadFn, fn);
    }else{
      loadFn && loadFn();
    }
  });
};

const dashArrayList = [
  { label: '实线', value: '0', },
  { label: '虚线', value: '5,5', },
  { label: '点线', value: '1,5', },
]

const dashArrayChangeFn = (target, input, value)=>{
  // console.log(target, input, value);
  const layer = props.layer;
  if(!layer)return;
  layer.setStyle && layer.setStyle({
    dashArray: value,
  })
}
const colorChangeFn = (target, input, value)=>{
  // console.log(target, input, value);
  const layer = props.layer;
  if(!layer)return;
  layer.setStyle && layer.setStyle({
    color: value,
  })
}
const weightChangeFn = (target, input, value)=>{
  // console.log(target, input, value);
  const layer = props.layer;
  if(!layer)return;
  layer.setStyle && layer.setStyle({
    weight: value,
  })
}

const buttonList = ref([
  { name: props.close?'关闭':'删除', fun: delFn, type: 'danger', },
  { name: '确定', fun: submit, type: 'primary', },
]);
const inputList = ref([
  { name: '图层名称', prop: 'name', type: 'text' },
  { name: '图层分组', prop: 'favoriteId', type: 'select',
    select: {
      list: 'favoriteList',
      label: 'name',
      value: 'id',
      filterable: true,
    }
  },
  { name: '目的', prop: 'purpose', type: 'text' },
  { name: '拍摄信息', prop: 'relatedInformation', type: 'KeyValList',
    KeyValList: {
      list: 'echoList',
      key: 'type',
      value: 'refer',
      typeList: {
        label: 'dictLabel',
        value: 'dictValue',
      }
    },
  },
  { name: '关联位置', prop: 'relatedPosition', type: 'KeyValList',
    KeyValList: {
      list: 'echoList',
      key: 'type',
      value: 'refer',
      typeList: {
        label: 'dictLabel',
        value: 'dictValue',
      }
    },
  },
  { name: '备注', prop: 'remark', type: 'textarea' },
]);
const rules = reactive({
  name: [
    { required: true, message: '请输入图层名称', trigger: 'blur' },
  ],
  favoriteId: [
    { required: true, message: '请选择图层分组', trigger: 'blur' },
  ],
});

const targetInit = ()=>{
  props.target['relatedInformation'] = props.target['relatedInformation']?JSON.parse(props.target['relatedInformation']):[];
  props.target['relatedPosition'] = props.target['relatedPosition']?JSON.parse(props.target['relatedPosition']):[];
  props.target['dashArrayList'] = dashArrayList;
  props.target['dashArray'] = props.target['dashArray'] || '0';
  props.target['weight'] = props.target['weight'] || 3;
  props.target['fill'] = props.target['fill'] || '#3388ff';
},
inputListInit = ()=>{
  if(!(props.layer instanceof L.Marker)){
    inputList.value.push(
      { name: '宽度', prop: 'weight', type: 'number',
        number: {
          min: 1,
        },
        changeFun: weightChangeFn,
      },
      { name: '样式', prop: 'dashArray', type: 'select',
        select: {
          list: 'dashArrayList',
          label: 'label',
          value: 'value',
          changeFun: dashArrayChangeFn,
        },
      },
      { name: '颜色', prop: 'fill', type: 'color',
        changeFun: colorChangeFn,
      },
    )
  }
}

const osmClick = (item)=>{
  const flag = props.target['relatedPosition'].some((e)=>{
        return JSON.stringify(e['geojson'] || '') === JSON.stringify(item['geojson']);
      });
  if(flag)return;
  const target = Object.assign({
    ...item,
  }, {
    type: `${ JSON.stringify(item['geojson']) }`,
    refer: `${ item['geojson']['properties']['name'] || '' }`,
    webDataType: 'osm',
  })
  props.target['relatedPosition'] && props.target['relatedPosition'].push(target);
  return true;
}

const eventClick = (event)=>{
  // console.log(event);
  const flag = props.target['relatedPosition'].some(item=>{
    return item.type ==`${ roundToThree(event.lat) },${ roundToThree(event.lon) }` 
  })
  if(flag)return;
  const target = Object.assign({
    ...event,
  }, {
    type: `${ roundToThree(event.lat) },${ roundToThree(event.lon) }`,
    refer: event['eventName'],
    webDataType: 'event',
  })
  props.target['relatedPosition'] && props.target['relatedPosition'].push(target);
}

const eventAllClickShowFlag = ref(true);
const eventAllClick = ()=>{
  getEventListByCoordinatesFn('2024-08-01', '2099-01-01', ()=>{
    eventAllClickShowFlag.value = false;
  });
}

const eventList = ref([]),
getEventListByCoordinatesFn = (start, end, callback)=>{
  const layer = props.layer;
  const flag = layer instanceof L.Polygon;
  if(!checkAdmin.value)return;
  if(!flag)return;
  const startTime = start || props.target['eventSt'],
        endTime = end || props.target['eventEt'];
  if(!startTime || !endTime)return;
  getEventListByCoordinates({
    minLat: layer.getBounds().getSouthEast().lat,
    minLon: layer.getBounds().getNorthWest().lng,
    maxLat: layer.getBounds().getNorthWest().lat,
    maxLon: layer.getBounds().getSouthEast().lng,
    geom: layer.toGeoJSON && JSON.stringify(layer.toGeoJSON()),
    st: startTime,
    et: endTime,
  }).then(res=>{
    if(res.data.code == 1004){
      eventList.value = JSON.parse(res.data.data);
      callback && callback();
    }
  }).catch(err=>{
    console.log(err);
  });
},
getMapBoxPlacesGeometryFn = ()=>{
  const layer = props.layer;
  const flag = layer instanceof L.Polygon;
  if(!checkAdmin.value)return;
  if(!flag)return;
  getMapBoxPlacesGeometry({
    minLat: layer.getBounds().getSouthEast().lat,
    minLon: layer.getBounds().getNorthWest().lng,
    maxLat: layer.getBounds().getNorthWest().lat,
    maxLon: layer.getBounds().getSouthEast().lng,
  }).then(res=>{
    if(res.data.code == 1004){
      osmDataInit(res.data.data);
    }
  }).catch(err=>{
    console.log(err);
  });
}
const osmDefaultColor = 'rgb(242, 186, 44)', osmCheckColor = 'rgb(226, 84, 101)';
const osmLayerGroup = L.featureGroup(),
      osmLayerGroupClose = ()=>{
        map.removeLayer(osmLayerGroup);
      }
const osmDataInit = (data)=>{
  const relatedPositionList = props.target['relatedPosition'];
  JSON.parse(data).forEach(item=>{
    if(
      relatedPositionList.some((e)=>{
        return JSON.stringify(e['geojson'] || '') === JSON.stringify(item['geojson']);
      })
    )return;
    let bindText = '';
    const properties = item['geojson']['properties'];
    // for(const key in properties){
    if(properties['name']){
      bindText+=`<p>${properties['name']}</p>`
    }
    // }
    const geojson = L.geoJSON(item['geojson'], {
      onEachFeature: (feature, layer)=>{
        layer.setStyle({
          color: osmDefaultColor,
        })
      },
    }).on({
      click: event=>{
        const flag = osmClick(item);
        if(flag)geojson.setStyle({
          color: osmCheckColor
        })
      }
    }).addTo(osmLayerGroup);
    if(bindText != ''){
      geojson.bindTooltip(bindText, {
        // offset: [0, 10],
        sticky: true,
        className: "leaflet-tooltip-message",
        direction: 'top',
        // maxWidth: 300,
        // maxHeight: 20,
        // permanent: true,
      })
    }
  })
  if(map.hasLayer(props.layer)){
    osmLayerGroup.addTo(map);
  }
}

const layerRemoveEventInit = ()=>{
  const layer = props.layer;
  const removeFn = ()=>{
    osmLayerGroupClose();
    layer.off('remove', removeFn);
  }
  layer.on('remove', removeFn);
}

const roundToThree = (num)=> {
  return Math.round(num * 1000) / 1000;
}

const queryExposurePropertiesFn = ()=>{
  if(store.getters['roleName'] === '用户')return;
  const layer = props.layer;
  const flag = layer instanceof L.Polygon || layer instanceof L.Circle;
  if(!flag)return;
  if(tileMap.value.size == 0)return;
  let geojson;
  if(layer instanceof L.Circle){
    const latlng = layer.getLatLng();
    geojson = turf.circle([latlng.lng, latlng.lat], layer.getRadius() / 1000, {
      steps: 64, units: 'kilometers',
    });
  }else{
    geojson = layer.toGeoJSON();
  }
  const tileIds = Array.from(tileMap.value.keys());
  
  queryExposureProperties({
    mapIdList: tileIds,
    geom: JSON.stringify(geojson.geometry || geojson),
  }).then(res=>{
    if(res.data.code == 1004){
      res.data.dataList.forEach(item=>{
        const flag = props.target['relatedInformation'].some(item=>{
          return item.type ==`${ roundToThree(item.lat) },${ roundToThree(item.lon) }` 
        })
        if(flag)return;
        props.target['relatedInformation'] && props.target['relatedInformation'].push({
          type: `${ roundToThree(item.lat) },${ roundToThree(item.lon) }`,
          refer: `${ item.scanSatelliteType } ${ item.scanProductTime }`,
        })
      })
    }
  }).catch(err=>{
    console.log(err);
  });
}

// 组件挂载前
onBeforeMount(()=>{

});
// 组件挂载后
onMounted(()=>{
  targetInit();
  layerRemoveEventInit();
  inputListInit();
  queryExposurePropertiesFn();
  getEventListByCoordinatesFn();
  getMapBoxPlacesGeometryFn();
});
// 组件更新后
onUpdated(()=>{

});
// 组件销毁后
onUnmounted(()=>{
  
});

</script>

<style lang='less'>

</style>

<style lang='less' scoped>
.edit-polygon-container{
  .event-select-scrollbar{
    padding: 5px 0;
    :deep(.el-scrollbar__view){
      display: flex;
      flex-wrap: wrap;
      flex-direction: column;
      gap: 5px;
      .event-select-item{
        line-height: 24px;
        font-size: 16px;
        padding: 5px;
        border-radius: var(--borderRadiusSize);
        cursor: pointer;
        &:hover{
          background-color: var(--backgroundColor_29);
          color: var(--fontColor_13);
        }
      }
      .event-all-select-item{
        text-align: center;
      }
    }
  }
}
</style>